import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import './ReportModal.css';

interface ReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  sessionId: string;
  questionNumber: number;
  onSubmit: (reportType: string, description: string) => void;
}

interface ReportType {
  value: string;
  label: string;
}

const ReportModal: React.FC<ReportModalProps> = ({
  isOpen,
  onClose,
  questionNumber,
  onSubmit
}) => {
  const [reportTypes, setReportTypes] = useState<ReportType[]>([]);
  const [selectedType, setSelectedType] = useState('');
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const loadReportTypes = async () => {
      if (!isOpen) return;
      try {
        const response = await api.get<{ reportTypes: ReportType[] }>('/report/types');
        if (response.success && response.data) {
          setReportTypes(response.data.reportTypes);
        }
      } catch (error) {
        console.error(error);
      }
    };

    loadReportTypes();
  }, [isOpen]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedType) return;

    setIsSubmitting(true);
    try {
      await onSubmit(selectedType, description);
      setSelectedType('');
      setDescription('');
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="report-modal-overlay" onClick={onClose}>
      <div className="question-report-modal" onClick={e => e.stopPropagation()}>
        <div className="report-modal-header">
          <h3>문제 신고</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit} className="report-form">
          <div className="question-report-group">
            <label>문제 번호: {questionNumber}</label>
          </div>
          
          <div className="question-report-group">
            <label htmlFor="reportType">신고 유형 *</label>
            <select
              id="reportType"
              value={selectedType}
              onChange={e => setSelectedType(e.target.value)}
              required
            >
              <option value="">선택해주세요</option>
              {reportTypes.map(type => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>
          
          <div className="question-report-group">
            <label htmlFor="description">상세 내용</label>
            <textarea
              id="description"
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="문제점을 자세히 설명해주세요"
              rows={4}
            />
          </div>
          
          <div className="question-report-actions">
            <button type="button" onClick={onClose} disabled={isSubmitting}>
              취소
            </button>
            <button type="submit" disabled={!selectedType || isSubmitting}>
              {isSubmitting ? '제출 중...' : '신고하기'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportModal;
